import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps, Switch, useHistory } from 'react-router-dom';
import { Location } from 'history';

import { PATHS } from 'src/appConfig/paths';
import { Screen } from 'src/components/common';
import Navbar from 'src/components/Navbar';
import { Navigator } from 'src/services';
import { IRootState } from 'src/redux/rootReducer';
import Dev from './Dev';
import HomeContainers from './HomeContainers';

import Signin from './UAMContainer/Signin';
import ModalContainer from './StartupContainers/ModalContainer';
import NotFound from './StartupContainers/NotFound';
import SplashScreen from './StartupContainers/SplashScreen';
import LoadingContainer from './StartupContainers/LoadingContainer';
import ToastContainer from './StartupContainers/ToastContainer';
import AuthContainer from './StartupContainers/AuthContainer';
import ResponsiveContainer from './StartupContainers/ResponsiveContainer';
// import Signup from './UAMContainer/Signup';
import ForgotPassword from './UAMContainer/ForgotPassword';
import ResetPassword from './UAMContainer/ResetPassword';
import TimesheetContainers from './TimesheetContainers';
import ContentContainer from './StartupContainers/ContentContainer';

const Routing: React.FC<{ location: Location }> = props => {
  Navigator.setTopHistory(useHistory());

  return (
    <Screen>
      <Navbar />
      <Switch location={props.location}>
        <CustomRoute path={PATHS.signIn} component={Signin} />
        {/* <CustomRoute path={PATHS.signUp} component={Signup} /> */}
        <CustomRoute path={PATHS.forgotPassword} component={ForgotPassword} />
        <CustomRoute path={PATHS.firstTimeLogin} component={ForgotPassword} />
        <CustomRoute path={PATHS.resetPassword} component={ResetPassword} />
        <CustomRoute pageRequiredAuth path={PATHS.root} component={HomeContainers} exact />
        <CustomRoute pageRequiredAuth path={PATHS.home} component={HomeContainers} />
        <CustomRoute pageRequiredAuth path={`${PATHS.updateTimesheet}/:id`} component={TimesheetContainers} />
        <CustomRoute pageRequiredAuth path={`${PATHS.createTimesheet}`} component={TimesheetContainers} />
        {/* <Route path={PATHS.dev} component={Dev} /> */}

        <CustomRoute path={PATHS.dev} component={Dev} />
        <Route component={NotFound} />
      </Switch>
      <AuthContainer />
      <LoadingContainer />
      <ModalContainer />
      <ToastContainer />
      <ResponsiveContainer />
      <ContentContainer />
    </Screen>
  );
};

export default Routing;

const CRouting: React.FC<Props> = ({ isAuthenticated, userPermissions, pageRequiredAuth, component, ...rest }) => {
  const renderRoute = (Component: any) => (props: RouteProps) => {
    if (isAuthenticated === null) return <SplashScreen />;

    if ((isAuthenticated && pageRequiredAuth) || (!isAuthenticated && !pageRequiredAuth)) {
      // Before render component, check permission first
      return <Component {...props} />;
    }

    const redirectPath = isAuthenticated ? PATHS.home : PATHS.signIn;
    const redirectProps = {
      to: {
        pathname: redirectPath,
        state: { from: props.location },
      },
    };
    return <Redirect {...redirectProps} />;
  };

  return <Route {...rest} render={renderRoute(component)} />;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps & { pageRequiredAuth?: boolean };

const mapStateToProps = (state: IRootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userPermissions: state.auth.permissions,
});

const mapDispatchToProps = {};

const CustomRoute = connect(mapStateToProps, mapDispatchToProps)(CRouting);
